import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll, IonSelect } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { IfStmt } from '@angular/compiler';
declare var app;

@Component({
  selector: 'app-a2-sales-summary-kpi',
  templateUrl: './a2-sales-summary-kpi.component.html',
  styleUrls: ['./a2-sales-summary-kpi.component.scss']
})
export class A2SalesSummaryKPIComponent extends GridBaseCase {
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild('selectDom') ionSelect: IonSelect;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName: string = null;
  tabsIndex: number = 0;
  selectVal = null;//搜索月份
  selectVal2 = null;//门店名称、pg名称或手机号
  summary:any = {};//汇总数据
  PGList:any = [];//pg列表
  selectStoreId:string = null;//门店id
  isShowSelect:boolean = true;//
  isDuDaoFlag:boolean=true;//督导角色
  step: number = 0; // 列表加载
  Show:boolean = false;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.selectVal = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month);
    localStorage.setItem("salesSummaryKpiDate",this.selectVal);
    this.base.account.Roles.forEach(role=>{
      if(role.Code=="1003"){
      this.isDuDaoFlag = false;
      }
      });
      
      
  }

  /**
   * 搜索
   */
  searchEvent(){
    this.LoadData(1);
    localStorage.setItem("salesSummaryKpiDate",this.selectVal);
  }

  /**
   * 选择日期
   * @param $event 
   */
  dateChange($event){
    // let that = this;
    // const date = $event.target.value || "";
    // that.LoadKPIData();
    // that.LoadData(1);
  }


  EventLink(event, item) {
    // console.log(item);
    // localStorage.setItem("information", JSON.stringify(item));
    // this.com.setHistoryUrl();
    // this.router.navigate([event.url + item.id.value + "&" + this.com.getNowDatetime]);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadKPIData() {
    
  }
 // 下拉显示
 arrowSee(event, item,i) {
   const that = this;
  that.dataArrayList.forEach((ite,dateindex)=>{
    if(i !== dateindex){
      ite.Show = false;
    }
  })
  if(i === that.step){
    item.Show = !item.Show;
  }else{
    item.Show =true;
  }
  that.step = i;
}

  LoadData(PageNumber) {
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }            
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName="get_PPSORPGSMTDKPIRetail";//"get_PPSORPGSMTDKPI";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    const _year = that.selectVal.split("-")[0];
    const _month = that.selectVal.split("-")[1];
    let day = new Date(_year, _month, 0);
    let startDate = _year + "-" + _month + "-" + "01" + " 00:00:00";
    let endDate = _year + "-" + _month + "-" + day.getDate() + " 23:59:59";
    let _Obj = {};
    if(that.selectVal2){
      _Obj = {
        query:that.selectVal2.toString().trim(),
        date:_year + "-"+_month+"-01"
        // date:_year + "-"+"07"+"-01"
      };
    }else{
      _Obj = {
        date:_year + "-"+_month+"-01"
        // date:_year + "-"+"07"+"-01"
      };
    }
    body.RequestBody = JSON.stringify(_Obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.summary["newclient"]=data.Status.newclient; // 招募会员总数
        that.summary["num"]=data.Status.num; // 总会员目标

        that.summary["sumprice"]=data.Status.sumprice; // 总销量
        that.summary["volume"]=data.Status.volume; // 总销量目标


        that.summary["bmsprice"]=data.Status.bmsprice; // BMS总销量
        that.summary["BMSVolume"]=data.Status.BMSVolume; // BMS总目标

        that.summary["nonbmsprice"]=data.Status.nonbmsprice; // Non-BMS 总销量
        that.summary["NonBMSVolume"]=data.Status.NonBMSVolume; // Non-BMS 总目标
        if(data.Status.StoreInfo && data.Status.StoreInfo.length > 0){
          data.Status.StoreInfo.forEach(items => {
            that.dataArrayList.push(items);
            items.Show= false;
          });
          that.dataArrayList[0].Show = true;
          console.log(that.dataArrayList);
          that.dataArrayList.forEach(item=>{
            let renshu:any = (item["CountLoyal"] ||0)+(item["CountMMP"] ||0)+(item["CountS3"] ||0);
            item["zhaomNum"]=renshu;
            let xiaoliang:any = (item["bmsprice"] ||0)+(item["nonbmsprice"] ||0);
            item["sumprices"]=xiaoliang;
            
          })
        }
        // if(PageNumber != 1){
        //   that.dataArrayList = that.dataArrayList.concat(data.Status.Datas.StoreInfo);
        // }else{
        //   that.dataArrayList = data.Status.Datas;
        // }
        // that.dataArrayList.forEach(function (item) {
        //   if(item["a_SNStartDate"]){
        //     item["a_SNStartDate"] = item["a_SNStartDate"].toString().replace(/-/g,"/");
        //   }
        //   if(item["SaleDay"]){
        //     item["SaleDay"] = item["SaleDay"].toString().replace(/-/g,"/");
        //   }
        //   if(item["Code"]){
        //     item["Code"] = item["Code"].toString().replace(/-/g,"/");
        //   }
        //   if(that.tabsIndex == 2){//考勤列表
        //     if(!item["a_StartDate"] && !item["a_EndDate"]){
        //       item["a_WorkState"] = "未上班";
        //     }else if(item["a_StartDate"] && !item["a_EndDate"]){
        //       item["a_WorkState"] = "已上班";
        //     }else if(item["a_StartDate"] && item["a_EndDate"]){
        //       item["a_WorkState"] = "已下班";
        //     }
        //   }
        // })
       
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.dataArrayList = [];
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  EventClick(item){
    const that = this;
    if(item["ChineseInfo"]){
      const _param = item["ChineseInfo"].split(",");
      if(_param.length > 1){
        that.PGList = [];
        _param.forEach((items,indexs)=>{
         let custermeritems:any=item.CustomerIDs.split(",")[indexs];
          const _itemArr = items.split("|");
          const _name = _itemArr[0] || "--";
          const _phone = _itemArr[1] || "--";
          const _pgId = _itemArr[2] || "";
          that.PGList.push({
            pgId:_pgId,
            storeid:item.ID,
            code:custermeritems,
            name:_name+"（"+_phone+"）"
          });
        })
        setTimeout(()=>{
          that.selectStoreId = item.ID;
          that.ionSelect.open();
        });
      }else if(_param.length == 1){
        that.com.setHistoryUrl(false);
        const _itemArr = _param[0].split("|");
        const _pgId = _itemArr[2] || "";
        if(that.com.GetAccount.BuType!="NTS"){
          const _year = that.selectVal.split("-")[0];
            const _month = that.selectVal.split("-")[1];
            localStorage.setItem("tbstore",JSON.stringify({"ID":item.ID}));
          // that.router.navigate(["/tabs/contact/SalesNewReport/view/summaryKPI&"+_pgId+"&"+item.ID+"&"+this.com.getNowDatetime],{
          //   queryParams: {
          //     userCode:item.CustomerIDs,
          //     ID: item.ID, // 门店id
          //     yearmonth: _year + "/"+_month
          //   }
          // });
          let  queryObj={
            userCode:item.CustomerIDs,
            ID: item.ID, // 门店id
            yearmonth: _year + "/"+_month
          }
          that.com.Go("/tabs/contact/SalesNewReport/view/summaryKPI&"+_pgId+"&"+item.ID+"&"+this.com.getNowDatetime,queryObj);
        }else{
          const _year = that.selectVal.split("-")[0];
          const _month = that.selectVal.split("-")[1];
          localStorage.setItem("tbstore",JSON.stringify({"ID":item.ID}));
          // that.router.navigate(["/tabs/contact/SalesReport/view/summaryKPI&"+_pgId+"&"+item.ID+"&"+this.com.getNowDatetime],
          // {
          //   queryParams:{
          //     userCode:item.CustomerIDs,
          //     ID: item.ID, // 门店id
          //     yearmonth: _year + "/"+_month
          //   }
           
          // });
          let summObj = {
            userCode:item.CustomerIDs,
            ID: item.ID, // 门店id
            yearmonth: _year + "/"+_month
          }
          that.com.Go("/tabs/contact/SalesReport/view/summaryKPI&"+_pgId+"&"+item.ID+"&"+this.com.getNowDatetime,summObj);
        }
        // that.router.navigate(["/tabs/contact/SalesReport/view/summaryKPI&"+_pgId+"&"+item.ID+"&"+this.com.getNowDatetime]);
        
      
        
      }
    }
  }

  /**
   * 选择pg
   * 
   */
  changePGSelect(event){
    const that = this;
    that.isShowSelect = false;
    let val = event.target.value;
    let code="";
    if(that.PGList.find(t=>t.pgId==val)){
      code=that.PGList.find(t=>t.pgId==val)["code"];
      let storeid=that.PGList.find(t=>t.pgId==val)["storeid"];
      localStorage.setItem("tbstore",JSON.stringify({"ID":storeid}));
    }
    if(val){
      that.com.setHistoryUrl();
      if(that.com.GetAccount.BuType!="NTS"){
        const _year = that.selectVal.split("-")[0];
          const _month = that.selectVal.split("-")[1];
        // that.router.navigate(["/tabs/contact/SalesNewReport/view/summaryKPI&"+val+"&"+that.selectStoreId+"&"+this.com.getNowDatetime],{
        //   queryParams: {
        //     userCode:code,
        //     ID: that.selectStoreId, // 门店id
        //     yearmonth: _year + "/"+_month
        //   }
        // });
        let urserObj = {
          userCode:code,
          ID: that.selectStoreId, // 门店id
          yearmonth: _year + "/"+_month
        }
        that.com.Go("/tabs/contact/SalesNewReport/view/summaryKPI&"+val+"&"+that.selectStoreId+"&"+this.com.getNowDatetime,urserObj);
      }else{
        const _year = that.selectVal.split("-")[0];
        const _month = that.selectVal.split("-")[1];
        // that.router.navigate(["/tabs/contact/SalesReport/view/summaryKPI&"+val+"&"+that.selectStoreId+"&"+this.com.getNowDatetime],{
        //   queryParams: {
        //     userCode:code,
        //     ID: that.selectStoreId, // 门店id
        //     yearmonth: _year + "/"+_month
        //   }
        // });
        let salesObj = {
          userCode:code,
          ID: that.selectStoreId, // 门店id
          yearmonth: _year + "/"+_month
        }
        that.com.Go("/tabs/contact/SalesReport/view/summaryKPI&"+val+"&"+that.selectStoreId+"&"+this.com.getNowDatetime,salesObj);
      }
    }else{
      that.msg.Alert("请选择促销员！");
    }
    setTimeout(()=>{
      that.isShowSelect = true;
    },1000);
  }
}
